import { Flex, Text } from '@cmpsr/components';
import TestBadge from '../test-badge/test-badge';
type TestItemProps = {
  value: number;
  title: string;
  description: string;
};

export default function TestItem({ value, title, description }: TestItemProps) {
  return (
    <Flex direction="row" gap={3} mb={4}>
      <TestBadge value={value} />

      <Text as="span" variant="text-body-regular">
        <Text as="span" variant="text-body-bold">
          {title}:{' '}
        </Text>
        {description}
      </Text>
    </Flex>
  );
}
